import React from "react";
import AppTemplate from "../components/ReservationCancelDetail";

const ReservationCancelDetail: React.FC = () => {
  return (
    <AppTemplate>
      <>ダッシュボード</>;
    </AppTemplate>
  );
};

export default ReservationCancelDetail;
